import { render } from "./page-main.vue?vue&type=template&id=b8730e48"
import script from "./page-main.vue?vue&type=script&lang=js"
export * from "./page-main.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__